var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'column position-relative',
    _vm.colType,
    {
      answer: _vm.cell.isAnswer,
    },
  ],style:({ height: `${_vm.cell.height}%` })},[(_vm.cell.children && _vm.cell.children.length > 0)?_vm._l((_vm.cell.children),function(c_cell){return _c('puzzle-cell',{key:c_cell.positiony + c_cell.positionx,attrs:{"cell":c_cell}})}):[_c('p',{style:({ fontSize: !_vm.cell.isAnswer ? `${_vm.cell.settings.font_size}px` : null})},[_vm._v(_vm._s(_vm.cell.text))])],(_vm.cell.arrow_position && _vm.cell.arrow_position.slug)?_c('div',{class:['arrow', `position_${_vm.cell.arrow_position.slug}`]},[(_vm.cell.arrow_direction && _vm.cell.arrow_direction.slug)?_c('div',{class:['arrow', `direction_${_vm.cell.arrow_direction.slug}`]}):_vm._e()]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }